import { ActionCreator } from 'redux';

import { Channel } from '@dev/ee-api/ee-api-models';
import {
    LoadChannelsSuccessAction,
    LoadChannelsErrorAction,
    LoadSingleChannelStartAction,
    LoadSingleChannelSuccessAction,
    LoadSingleChannelErrorAction,
    FindChannelsAction,
    ExportChannelsAction,
    ExportChannelsErrorAction,
    ExportChannelsStartAction,
    ExportChannelsSuccessAction,
    ChannelsPayload,
    ClearChannelsScreenAction,
    StatisticsChannelsState,
    ChannelsActionTypes,
} from './types';

import { ExportChannelsParams } from '@api/services/ElasticApi';
import { store } from '@shared-store/shared-store';
import { ApplicationState } from '..';
export const LoadChannelsStart = (params: ChannelsPayload) => {
    return {
        type: ChannelsActionTypes.LOAD_ALL,
        payload: params,
    };
};
export const LoadChannelsSuccess: ActionCreator<LoadChannelsSuccessAction> = (payload: {
    channels?: Channel[];
    channelsPreview?: Channel[];
    totalCount?: number;
    activePage?: number;
    perPage?: number;
    hasMore?: boolean;
}) => {
    return {
        type: ChannelsActionTypes.LOAD_ALL_SUCCESS,
        payload,
    };
};

export const LoadChannelsError: ActionCreator<LoadChannelsErrorAction> = () => {
    return {
        type: ChannelsActionTypes.LOAD_ALL_ERROR,
        payload: {
            loading: false,
        },
    };
};

export const LoadSingleChannelStart: ActionCreator<LoadSingleChannelStartAction> = (name: string) => {
    return {
        type: ChannelsActionTypes.LOAD_SINGLECHANNEL_START,
        payload: {
            singleChannelLoading: true,
            name,
        },
    };
};
export const LoadSingleChannelSuccess: ActionCreator<LoadSingleChannelSuccessAction> = (singleChannel: Channel) => {
    return {
        type: ChannelsActionTypes.LOAD_SINGLECHANNEL_SUCCESS,
        payload: {
            singleChannelLoading: false,
            singleChannel,
        },
    };
};
export const LoadSingleChannelError: ActionCreator<LoadSingleChannelErrorAction> = () => {
    return {
        type: ChannelsActionTypes.LOAD_SINGLECHANNEL_ERROR,
        payload: {
            singleChannelLoading: false,
        },
    };
};

export const ExportChannels: ActionCreator<ExportChannelsAction> = (params: ExportChannelsParams) => ({
    type: ChannelsActionTypes.EXPORT_CHANNELS,
    payload: params,
});
export const ExportChannelsStart: ActionCreator<ExportChannelsStartAction> = () => ({
    type: ChannelsActionTypes.EXPORT_CHANNELS_START,
});
export const ExportChannelsError: ActionCreator<ExportChannelsErrorAction> = () => ({
    type: ChannelsActionTypes.EXPORT_CHANNELS_ERROR,
});
export const ExportChannelsSuccess: ActionCreator<ExportChannelsSuccessAction> = () => ({
    type: ChannelsActionTypes.EXPORT_CHANNELS_SUCCESS,
});

export const FindChannels: ActionCreator<FindChannelsAction> = (params?: ChannelsPayload) => {
    const activePage = store.getState().channels.activePage;

    if (activePage > 1) {
        params.activePage = 1;
    }

    return {
        type: ChannelsActionTypes.SEARCH_FOR_CHANNELS,
        payload: params,
    };
};

export const ClearChannelsScreen: ActionCreator<ClearChannelsScreenAction> = () => ({
    type: ChannelsActionTypes.CLEAR_DATA,
});

export const ClearChannels = () => ({
    type: ChannelsActionTypes.CLEAR_CHANNELS,
});

export const getChannelsStore = (state: ApplicationState): StatisticsChannelsState => state.channels;
